export default {
  path: '/notes',
  component: () => import('@/views/notes/index.vue'),
  children: [
    {
      path: 'delivery-note',
      name: 'DeliveryNote',
      component: () => import('@/views/notes/page/DeliveryNote.vue'),
      meta: {
        middleware: [
          'auth',
          'management',
          'creative',
          'area_manager',
          'marketing',
          'developer',
          'merchandising_planner',
          'merchandiser',
          'online_admin',
          'support',
          'inventory_and_costing',
          'warehouse_manager',
          'warehouse',
          'store_manager',
          'acting_assist_store_manager',
          'accounting_manager',
          'accounting',
          'vm',
          'assist_store_manager',
          'sales_staff'
        ],
        layout: 'Blank'
      }
    },
    {
      path: 'delivery-note-new',
      name: 'DeliveryNoteNew',
      component: () => import('@/views/notes/page/DeliveryNoteNew.vue'),
      meta: {
        middleware: [
          'auth',
          'management',
          'area_manager',
          'marketing',
          'developer',
          'creative',
          'merchandising_planner',
          'merchandiser',
          'online_admin',
          'accounting_manager',
          'accounting',
          'support',
          'vm',
          'inventory_and_costing',
          'warehouse_manager',
          'warehouse',
          'store_manager',
          'acting_assist_store_manager',
          'assist_store_manager',
          'sales_staff'
        ]
      }
    },
    {
      path: 'withdraw-note-new',
      name: 'WithdrawNoteNew',
      component: () => import('@/views/notes/page/WithdrawNoteNew.vue'),
      meta: {
        middleware: [
          'auth',
          'management',
          'area_manager',
          'marketing',
          'developer',
          'creative',
          'merchandising_planner',
          'merchandiser',
          'online_admin',
          'accounting_manager',
          'accounting',
          'support',
          'vm',
          'inventory_and_costing',
          'warehouse_manager',
          'warehouse',
          'store_manager',
          'acting_assist_store_manager',
          'assist_store_manager',
          'sales_staff'
        ]
      }
    },
    {
      path: 'multi-delivery-note',
      name: 'MultiDeliveryNote',
      component: () => import('@/views/notes/page/MultiDeliveryNote.vue'),
      meta: {
        middleware: [
          'auth',
          'management',
          'creative',
          'area_manager',
          'marketing',
          'developer',
          'merchandising_planner',
          'merchandiser',
          'online_admin',
          'support',
          'inventory_and_costing',
          'warehouse_manager',
          'warehouse',
          'store_manager',
          'acting_assist_store_manager',
          'accounting_manager',
          'accounting',
          'vm',
          'assist_store_manager',
          'sales_staff'
        ],
        layout: 'Blank'
      }
    },
    {
      path: 'multi-withdraw-note',
      name: 'MultiWithdrawNote',
      component: () => import('@/views/notes/page/MultiWithdrawNote.vue'),
      meta: {
        middleware: [
          'auth',
          'management',
          'creative',
          'area_manager',
          'marketing',
          'developer',
          'merchandising_planner',
          'merchandiser',
          'online_admin',
          'support',
          'inventory_and_costing',
          'warehouse_manager',
          'warehouse',
          'store_manager',
          'acting_assist_store_manager',
          'accounting_manager',
          'accounting',
          'vm',
          'assist_store_manager',
          'sales_staff'
        ],
        layout: 'Blank'
      }
    },
    {
      path: 'withdraw-note',
      name: 'WithdrawNote',
      component: () => import('@/views/notes/page/WithdrawNote.vue'),
      meta: {
        middleware: [
          'auth',
          'management',
          'creative',
          'area_manager',
          'marketing',
          'developer',
          'merchandising_planner',
          'accounting_manager',
          'accounting',
          'merchandiser',
          'online_admin',
          'support',
          'inventory_and_costing',
          'warehouse_manager',
          'warehouse',
          'store_manager',
          'vm',
          'acting_assist_store_manager',
          'assist_store_manager',
          'sales_staff'
        ],
        layout: 'Blank'
      }
    }
  ]
}
